export default __webpack_public_path__ + "static/media/img-4.82a94fe6.png";